export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '©$YEAR$ Cerquity',
    address: 'GOCER s.r.l. Società Benefit - Via Langhe 126A 12060 Magliano Alpi (CN)',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
